'use strict';

document.querySelectorAll('.tab-pane').forEach(function (pane) {
	var input = pane.querySelector('.faq-search-input');
	var accordion = pane.querySelector('.accordion');
	if (!input || !accordion) return;

	var buttons = accordion.querySelectorAll('.accordion-button');
	var bodies = accordion.querySelectorAll('.accordion-body');

	buttons.forEach(function (btn) {
		btn.dataset.originalHtml = btn.innerHTML;
	});
	bodies.forEach(function (body) {
		body.dataset.originalHtml = body.innerHTML;
	});

	function clearHighlights() {
		buttons.forEach(function (btn) {
			btn.innerHTML = btn.dataset.originalHtml;
		});
		bodies.forEach(function (body) {
			body.innerHTML = body.dataset.originalHtml;
		});
	}

	function highlightIn(elements, terms) {
		elements.forEach(function (el) {
			if (el.closest('.faq-item').style.display === 'none') return;
			var html = el.dataset.originalHtml;
			terms.forEach(function (term) {
				var escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
				html = html.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
			});
			el.innerHTML = html;
		});
	}

	function applyHighlights() {
		var terms = input.value.toLowerCase().split(' ').filter(Boolean);
		if (!terms.length) return;
		highlightIn(Array.from(buttons), terms);
		highlightIn(Array.from(bodies), terms);
	}

	jQuery(input).quicksearch('#' + accordion.id + ' .faq-item', {
		onBefore: clearHighlights,
		onAfter: applyHighlights,
	});

	input.addEventListener('keypress', function (e) {
		if (e.which === 13) e.preventDefault();
	});
});
